import React from "react";

import EmbeddedVideo from "./embeddedVideo";

class EmbeddedVideoContainer extends React.Component {
  constructor(props) {
    super(props);

    // arbitrary business logic
    this.fakeData = "fake data";
  }

  render() {
    return (
      <EmbeddedVideo
        videoId={this.props.data.videoId}
        host={this.props.data.embeddedVideoHost}
      />
    );
  }
}
export default EmbeddedVideoContainer;
